import { render, staticRenderFns } from "./globalSelect.vue?vue&type=template&id=7561c061&scoped=true"
import script from "./globalSelect.vue?vue&type=script&lang=js"
export * from "./globalSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7561c061",
  null
  
)

export default component.exports